import { ReactNode } from 'react';

type TProps = {
  title: ReactNode;
  description?: ReactNode;
}

const HeaderTitlePage = ({ title, description }: TProps) => (
  <div className='space-y-1'>
    <div className='text-2xl font-bold tracking-tight'>
      {title}
    </div>
    {
      description &&
      <div className='text-sm text-muted-foreground'>
        {description}
      </div>
    }
  </div>
);

export default HeaderTitlePage;
